module.exports = __webpack_public_path__ + "static/philg-5dbe2ae5d18b77dc036fff81ba81ddd5.png";